export default __webpack_public_path__ + "static/Flooding-5781135b22a7012fcec7caf822941ea2.jpg";